"use client";

import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const features = [{
  number: "01",
  title: "FDACS Certified",
  description: "We are fully licensed by the Florida Department of Agriculture and Consumer Services, ensuring the highest standards of safety and regulatory compliance.",
  technicalDetail: "Operating under strict Florida Chapter 482 regulations for structural pest control and termite treatment operations."
}, {
  number: "02",
  title: "ADVANCED TREATMENT TECH",
  description: "Our team utilizes the latest technologies to eliminate colonies at the source.",
  technicalDetail: "Deployment of non-repellent liquid residuals and hexaflumuron-based baiting systems for 24/7 structural protection."
}, {
  number: "03",
  title: "LOCAL KNOWLEDGE",
  description: "Based in Punta Gorda, we understand the unique pest pressures of Southwest Florida, from native subterranean termites to invasive Formosan, Asian, and West Indies Drywood Termites.",
  technicalDetail: "Targeted treatment protocols specifically designed for the humid subtropical climate and local soil compositions of Charlotte County."
}, {
  number: "04",
  title: "Fully Insured Peace",
  description: "Your property is protected by comprehensive liability coverage, providing total security during every service visit.",
  technicalDetail: "Maintained high-limit general liability insurance and specialized pollution liability coverage for professional pest management."
}];
export default function WhyNeighborsChooseWallice() {
  return <section data-section-id="223677" id="why-choose-peace-river" className="relative w-full bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.08]" style={{
      backgroundImage: "linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)",
      backgroundSize: "100% 32px"
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default tracking-tighter mb-4">
            Why Choose Peace River
          </h2>
          <p className="text-lg text-foreground font-serif max-w-2xl">
            We combine industrial-strength reliability with local Southwest Florida expertise to keep your home pest-free and protected.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          <TooltipProvider delayDuration={200}>
            {features.map((feature, i) => <Tooltip key={i}>
                <TooltipTrigger asChild data-index={i}>
                  <div className="group flex flex-col h-full p-8 rounded-none border-2 border-foreground bg-card hover:bg-accent transition-all duration-300 cursor-help text-left shadow-none hover:scale-[1.02]">
                    <div className="text-6xl md:text-7xl font-bold text-foreground/10 font-default mb-6 tracking-tighter select-none transition-colors group-hover:text-foreground/20">
                      {feature.number}
                    </div>
                    <h3 className="text-xl font-bold text-foreground font-default mb-3 uppercase">
                      {feature.title}
                    </h3>
                    <p className="text-foreground font-serif text-sm leading-relaxed mb-8 flex-grow">
                      {feature.description}
                    </p>
                    <div className="flex items-center text-xs font-bold text-foreground uppercase tracking-widest group-hover:text-primary-foreground transition-colors mt-auto">
                      <Info className="w-4 h-4 mr-2" />
                      Technical Detail
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" align="start" className="max-w-[280px] p-4 bg-primary text-primary-foreground border-2 border-foreground shadow-none rounded-none">
                  <p className="text-sm font-medium leading-relaxed font-default">
                    {feature.technicalDetail}
                  </p>
                </TooltipContent>
              </Tooltip>)}
          </TooltipProvider>
        </div>
      </div>
    </section>;
}